import moment from 'moment';
import QueryString from 'qs';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { getCanbotEvaluationItem, getCanbotSemesterInfo, saveCanbotEvaluation } from '../../api/mypage.api';
import { ICanbotEvaluationItem, IGetCanbotEvaluationItemResponse } from '../../models/mypage.model';
import useAxios from '../../hooks/useAxios';
import Button from '../../components/Button';
import { IResponse } from '../../models/common.api.model';
import useNotification from '../../hooks/useNotification';
import { Helmet } from 'react-helmet';
import Loader from '../../components/Loader';
import ErrorResponse from '../../components/ErrorResponse';

const Block = styled.div`
  .stt-player__area {
    position: absolute;
    top: 170px;
    right: 24px;
    display: flex;
    gap: 10px;
    height: 40px;
    margin-top: 20px;
    justify-content: flex-end;
    align-items: center;
    z-index: 10;
  }
  .stt-player__area audio {
    width: 240px;
    height: 53px;
    border-radius: 6px;
    background-color: #f1f3f4;
    transform: scale(0.75);
    transform-origin: right;
  }
  .stt-player__area .btn-basic {
    min-width: 51px;
    height: 40px;
  }

  .assessment-tab {
    margin-top: 30px;
  }

  .assessment-score {
    display: flex;
    align-items: center;
  }
  .assessment-score label {
    display: inline-flex;
    width: 70px;
    height: 40px;
    font-size: 12px;
    color: #2e4052;
    letter-spacing: -0.6px;
    margin-bottom: 0;
    align-items: center;
    justify-content: center;
  }
  .assessment-score .form-control,
  .assessment-score span {
    flex: 1 0 0%;
    flex-grow: 1;
  }
  .assessment-score .form-control {
    height: 40px;
    text-align: center;
  }
  .assessment-score span {
    display: block;
    text-align: center;
  }

  textarea.updated,
  .form-control.updated {
    background-color: rgba(187, 6, 101, 0.05);
    box-shadow: none !important;
  }

  .assessment-text__area {
    min-height: 56px;
  }

  .not-commenced__text {
    font-size: 12px;
    color: #bb0665;
    letter-spacing: -0.6px;
    text-align: right;
    margin-top: 10px;
    margin-bottom: 0;
  }
  
  .teacher-evaluation textarea {
    min-height: 70px;
  }

  .comm-table__area.rowType table textarea {
    padding: 5px;
  }
`;
export interface IQueryParams {
  rubricNo: number;
  resultCode: number;
  learningTlStructureNo: number;
  seq: number;
  activityCode: number;
  curriculumName: string;
  studentKorName: string;
  studentEngName: string;
  regDate: string;
  displayName: string;
  activityName: string;
  activityType: string;
  feedbackTypeCode: string;
  eduStepCode: string;
  isReadOnly: boolean;
  classCode: string;
  className: string;
  evaluatorName: string;
  evaluateDate: string;
  canbotTopic: string;
}

const TutorAssessCb = () => {

  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState<'teacher' | 'ai'>('teacher');

  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true }) as unknown as IQueryParams;
  const { infoNotification, successNotification, errorNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetCanbotEvaluationItemResponse>();
  const { data: resSemesterInfo, isLoading: isLoading2, error: error2, execute: executeSemesterInfo } = useAxios<IGetCanbotEvaluationItemResponse>();
  const { data: saveResult, isLoading: isSaving, error: saveError, execute: executeSave } = useAxios<IResponse<string>>();

  const {
    resultCode,
    curriculumName,
    studentKorName,
    regDate,
    displayName,
    activityName,
    feedbackTypeCode,
    className, 
    evaluatorName,
    evaluateDate,
    canbotTopic
  } = query;

  const [evaluationData, setEvaluationData] = useState<ICanbotEvaluationItem>();
  const [semesterInfoData, setSemesterInfoData] = useState<ICanbotEvaluationItem>();
  const [teacherComment, setTeacherComment] = useState<string>();
  const [teacherStComment, setTeacherStComment] = useState<string>();
  const [teacherWkComment, setTeacherWkComment] = useState<string>();
  const [teacherInComment, setTeacherInComment] = useState<string>();
  const [teacherCoComment, setTeacherCoComment] = useState<string>();
  const [teacherLuComment, setTeacherLuComment] = useState<string>();
  const [teacherInScore, setTeacherInScore] = useState<string>();
  const [teacherCoScore, setTeacherCoScore] = useState<string>();
  const [teacherLuScore, setTeacherLuScore] = useState<string>();
  const [mapTeacherCommentUpdated, setMapTeacherCommentUpdated] = useState<Map<string,boolean>>(new Map());

  useEffect(() => {
    if (resultCode) {
      execute(getCanbotEvaluationItem(resultCode));
      executeSemesterInfo(getCanbotSemesterInfo(resultCode));
    }
  }, [resultCode]);

  useEffect(() => {
    if (res) {
      setEvaluationData(res.data);

      const tempMapCommentUpdated = new Map<string,boolean>();
      //강사 평가 값이 있는 경우 강사평가 data 사용
      //강사 평가와 AI 평가 비교
      if(res.data.teacherGeneralComment) {
        setTeacherComment(res.data.teacherGeneralComment);
        if(isEqualIgnoreSpaces(res.data.aiGeneralCommentEn, res.data.teacherGeneralComment)) {
          tempMapCommentUpdated.set('teacherComment', true);
        } else {
          tempMapCommentUpdated.set('teacherComment', false);
        }
      } else {
        setTeacherComment(res.data.aiGeneralCommentEn);
        tempMapCommentUpdated.set('teacherComment', true);
      }

      if(res.data.stTeacherComment) {
        setTeacherStComment(res.data.stTeacherComment);
        if(isEqualIgnoreSpaces(res.data.stAiComment, res.data.stTeacherComment)) {
          tempMapCommentUpdated.set('teacherStComment', true);
        } else {
          tempMapCommentUpdated.set('teacherStComment', false);
        }
      } else {
        setTeacherStComment(res.data.stAiComment);
        tempMapCommentUpdated.set('teacherStComment', true);
      }

      if(res.data.wkTeacherComment) {
        setTeacherWkComment(res.data.wkTeacherComment);
        if(isEqualIgnoreSpaces(res.data.wkAiComment, res.data.wkTeacherComment)) {
          tempMapCommentUpdated.set('teacherWkComment', true);
        } else {
          tempMapCommentUpdated.set('teacherWkComment', false);
        }
      } else {
        setTeacherWkComment(res.data.wkAiComment);
        tempMapCommentUpdated.set('teacherWkComment', true);
      }

      if(res.data.teacherCommentIn) {
        setTeacherInComment(res.data.teacherCommentIn);
        if(isEqualIgnoreSpaces(res.data.aiCommentIn, res.data.teacherCommentIn)) {
          tempMapCommentUpdated.set('teacherInComment', true);
        } else {
          tempMapCommentUpdated.set('teacherInComment', false);
        }
      } else {
        setTeacherInComment(res.data.aiCommentIn);
        tempMapCommentUpdated.set('teacherInComment', true);
      }

      if(res.data.teacherCommentCo) {
        setTeacherCoComment(res.data.teacherCommentCo);
        if(isEqualIgnoreSpaces(res.data.aiCommentCo, res.data.teacherCommentCo)) {
          tempMapCommentUpdated.set('teacherCoComment', true);
        } else {
          tempMapCommentUpdated.set('teacherCoComment', false);
        }
      } else {
        setTeacherCoComment(res.data.aiCommentCo);
        tempMapCommentUpdated.set('teacherCoComment', true);
      }

      if(res.data.teacherCommentLu) {
        setTeacherLuComment(res.data.teacherCommentLu);
        if(isEqualIgnoreSpaces(res.data.aiCommentLu, res.data.teacherCommentLu)) {
          tempMapCommentUpdated.set('teacherLuComment', true);
        } else {
          tempMapCommentUpdated.set('teacherLuComment', false);
        }
      } else {
        setTeacherLuComment(res.data.aiCommentLu);
        tempMapCommentUpdated.set('teacherLuComment', true);
      }

      if(res.data.teacherScoreIn) {
        setTeacherInScore(res.data.teacherScoreIn);
        if(isEqualIgnoreSpaces(res.data.aiScoreIn, res.data.teacherScoreIn)) {
          tempMapCommentUpdated.set('teacherInScore', true);
        } else {
          tempMapCommentUpdated.set('teacherInScore', false);
        }
      } else {
        setTeacherInScore(res.data.aiScoreIn);
        tempMapCommentUpdated.set('teacherInScore', true);
      }

      if(res.data.teacherScoreCo) {
        setTeacherCoScore(res.data.teacherScoreCo);
        if(isEqualIgnoreSpaces(res.data.aiScoreCo, res.data.teacherScoreCo)) {
          tempMapCommentUpdated.set('teacherCoScore', true);
        } else {
          tempMapCommentUpdated.set('teacherCoScore', false);
        }
      } else {
        setTeacherCoScore(res.data.aiScoreCo);
        tempMapCommentUpdated.set('teacherCoScore', true);
      }

      if(res.data.teacherScoreLu) {
        setTeacherLuScore(res.data.teacherScoreLu);
        if(isEqualIgnoreSpaces(res.data.aiScoreLu, res.data.teacherScoreLu)) {
          tempMapCommentUpdated.set('teacherLuScore', true);
        } else {
          tempMapCommentUpdated.set('teacherLuScore', false);
        }
      } else {
        setTeacherLuScore(res.data.aiScoreLu);
        tempMapCommentUpdated.set('teacherLuScore', true);
      }

      setMapTeacherCommentUpdated(tempMapCommentUpdated);
    }
  }, [res]);

  useEffect(() => {
    if (resSemesterInfo) {
      setSemesterInfoData(resSemesterInfo.data);
    }
  },[resSemesterInfo]);

  useEffect(() => {
    if (saveResult) {
      if (saveResult.result === 'success') {
        if(saveResult.data === 'TP') {  
          successNotification(t('common.message.save1'));
        } else if(saveResult.data === 'TC') {
          successNotification(t('class.canbot.message1'));
        }
      } else if(saveResult.result === 'fail') {
        if(saveResult.data === 'PR') {  
          errorNotification(t('class.canbot.message2'));
        } else {
          errorNotification(t('common.message.error'));
        }
      } else {
        errorNotification(t('common.message.error'));
      }

      execute(getCanbotEvaluationItem(resultCode));
    }
  }, [saveResult]);

  useEffect(() => {
    if(saveError) {
        // 네트워크 에러 (서버 연결 불가)
        if (!saveError?.response?.status) {
          errorNotification(t('common.message.error'));
          return;
        }


        if(saveError.response?.data.data === 'EC') {  //완료된 평가
          errorNotification(t('class.canbot.message3'));
        } else {
          errorNotification(t('common.message.error'));
        }
    }
  }, [saveError]);

  const handleTabClick = (tab: 'teacher' | 'ai') => {
    setActiveTab(tab);
  };

  const isEqualIgnoreSpaces = (str1: string | undefined, str2: string | undefined) => {
    if(!str1 || !str2) return false;
    return str1.replace(/\s/g, '') === str2.replace(/\s/g, '');
  };

  const onSave = (type:string) => {

    //유효성 체크
    if(!teacherComment || !teacherStComment || !teacherWkComment || !teacherInComment || !teacherCoComment || !teacherLuComment || !teacherInScore || !teacherCoScore || !teacherLuScore) {
      return infoNotification(t('class.canbot.message4'));
    }

    const formData = new FormData();
    formData.append('teacherGeneralComment', teacherComment);
    formData.append('stTeacherComment', teacherStComment);
    formData.append('reportTaskStatusCode', type === 'C' ? 'TC' : 'TP');
    formData.append('reportTypeCode', 'UN');
    formData.append('wkTeacherComment', teacherWkComment);
    formData.append('teacherCommentIn', teacherInComment);
    formData.append('teacherCommentCo', teacherCoComment);
    formData.append('teacherCommentLu', teacherLuComment);
    formData.append('teacherScoreIn', teacherInScore);
    formData.append('teacherScoreCo', teacherCoScore);
    formData.append('teacherScoreLu', teacherLuScore);
    if(semesterInfoData) {
      formData.append('semesterYear', semesterInfoData.semesterYear || '');
      formData.append('semesterDiv', semesterInfoData.semesterDiv || '');
      formData.append('courseName', semesterInfoData.courseName || '');
    }
    executeSave(saveCanbotEvaluation(resultCode, formData));
  };

  return (
    <Block>
      <Helmet>
        <title>Assessment</title>
      </Helmet>
      <div className="ant-modal-header">
        <div className="ant-modal-title" id="rc_unique_2">Assessment</div>
      </div>
      <div className="ant-modal-body">
        <div className="comm-table__area mt-0">
          <table>
            <colgroup>
              <col width="120" />
              <col width="120" />
              <col width="120" />
              <col width="120" />
              <col width="366" />
              <col width="200" />
              <col width="120" />
              <col width="120" />
              {(evaluationData?.evaluateDate) && <col width="120" />}
              {(evaluationData?.evaluatorName) && <col width="120" />}
            </colgroup>
            <thead>
              <tr>
                <th>{t('class.class.column72')}</th>
                <th>{t('common.column.category')}</th>
                <th>{t('class.class.column11')}</th>
                <th>{t('common.column.activity')}</th>
                <th>{t('class.canbot.column1')}</th>
                <th>{t('class.class.column57')}</th>
                <th>{t('class.class.column47')}</th>
                <th>{t('common.column.date1')}</th>
                {(evaluationData?.evaluateDate) && <th>{t('class.eLearnAssess.button1')}</th>}
                {(evaluationData?.evaluatorName) && <th>{t('class.canbot.column2')}</th>}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{feedbackTypeCode === 'ST' ? 'Speaking' : 'Writing'}</td>
                <td>{displayName}</td>
                <td>{curriculumName}</td>
                <td>{activityName}</td>
                <td>{canbotTopic}</td>
                <td>{className}</td>
                <td>{studentKorName}</td>
                <td>{regDate ? moment(regDate, 'YYYYMMDD').format('YYYY.MM.DD') : ''}</td>
                {(evaluationData?.evaluateDate) && <td>{evaluationData?.evaluateDate}</td>}
                {(evaluationData?.evaluatorName) && <td>{evaluationData?.evaluatorName}</td>}
              </tr>
            </tbody>
          </table>
        </div>

        {isSaving ? <Loader /> : null}

        <div className="stt-player__area">
          {evaluationData?.canbotContentFileUrl && <audio controls src={evaluationData?.canbotContentFileUrl}></audio>}
        </div>

        <div className="comm-tab__line assessment-tab">
          <ul style={{ display: 'flex', listStyle: 'none', padding: 0 }}>
            <li className={activeTab === 'teacher' ? 'active' : ''} style={{ marginRight: 8 }}>
              <a className="btn-item" onClick={() => handleTabClick('teacher')} style={{ cursor: 'pointer' }}>
                Teacher's Evaluation
              </a>
            </li>
            <li className={activeTab === 'ai' ? 'active' : ''}>
              <a className="btn-item" onClick={() => handleTabClick('ai')} style={{ cursor: 'pointer' }}>
                AI's
              </a>
            </li>
          </ul>
        </div>

        {activeTab === 'teacher' ? (
          <div className="comm-table__area rowType teacher-evaluation">
            <table>
              <colgroup>
                <col width="160" />
                <col width="160" />
                <col width="*" />
              </colgroup>
              <tbody>
                <tr>
                  <th colSpan={2} className="text-center">Overall Comment</th>
                  <td>
                    <textarea 
                      className={mapTeacherCommentUpdated.get('teacherComment') ? '' : 'updated'}
                      value={teacherComment}
                      onChange={(e) => setTeacherComment(e.target.value)}
                    />
                  </td>
                </tr>
                <tr>
                  <th colSpan={2} className="text-center">Strength</th>
                  <td>
                    <textarea 
                      className={mapTeacherCommentUpdated.get('teacherStComment') ? '' : 'updated'}
                      value={teacherStComment}
                      onChange={(e) => setTeacherStComment(e.target.value)}
                    />
                  </td>
                </tr>
                <tr>
                  <th colSpan={2} className="text-center">Area for Improvement</th>
                  <td>
                    <textarea 
                      className={mapTeacherCommentUpdated.get('teacherWkComment') ? '' : 'updated'}
                      value={teacherWkComment}
                      onChange={(e) => setTeacherWkComment(e.target.value)}
                    />
                  </td>
                </tr>
                <tr>
                  <th className="text-center" colSpan={2}>Interaction</th>
                  <td rowSpan={2}>
                    <textarea 
                      className={mapTeacherCommentUpdated.get('teacherInComment') ? '' : 'updated'}
                      value={teacherInComment}
                      onChange={(e) => setTeacherInComment(e.target.value)}
                    />
                  </td>
                </tr>
                <tr>
                  <th className="text-center">Score</th>
                  <th className="text-center">
                    <div className='assessment-score'>
                      <input type="text" className={mapTeacherCommentUpdated.get('teacherInScore') ? 'form-control' : 'form-control updated'} value={teacherInScore} 
                        onChange={(e) => {
                          const value = e.target.value;
                          // 빈값이거나 1~5 사이 숫자만 허용
                          if (value === '' || (Number(value) >= 1 && Number(value) <= 5)) {
                            setTeacherInScore(value);
                          }
                        }} />
                    </div>
                  </th>
                </tr>
                <tr>
                  <th className="text-center" colSpan={2}>Coherence</th>
                  <td rowSpan={2}>
                    <textarea
                      className={mapTeacherCommentUpdated.get('teacherCoComment') ? '' : 'updated'}
                      value={teacherCoComment}
                      onChange={(e) => setTeacherCoComment(e.target.value)}
                    />
                  </td>
                </tr>
                <tr>
                  <th className="text-center">Score</th>
                  <th className="text-center">
                    <div className='assessment-score'>
                      <input type="text" className={mapTeacherCommentUpdated.get('teacherCoScore') ? 'form-control' : 'form-control updated'} value={teacherCoScore} 
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === '' || (Number(value) >= 1 && Number(value) <= 5)) {
                            setTeacherCoScore(value);
                          }
                        }} />
                    </div>
                  </th>
                </tr>
                <tr>
                  <th className="text-center" colSpan={2}>Language Use</th>
                  <td rowSpan={2}>
                    <textarea 
                      className={mapTeacherCommentUpdated.get('teacherLuComment') ? '' : 'updated'}
                      value={teacherLuComment}
                      onChange={(e) => setTeacherLuComment(e.target.value)}
                    />
                  </td>
                </tr>
                <tr>
                  <th className="text-center">Score</th>
                  <th className="text-center">
                    <div className='assessment-score'>
                      <input type="text" className={mapTeacherCommentUpdated.get('teacherLuScore') ? 'form-control' : 'form-control updated'} value={teacherLuScore} 
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === '' || (Number(value) >= 1 && Number(value) <= 5)) {
                            setTeacherLuScore(value);
                          }
                        }} />
                    </div>
                  </th>
                </tr>
              </tbody>
            </table>
            <div className="comm-bx__between">
              <div />
              <div className="comm-btn__area right">
                <Button
                  className="btn-basic pink-line"
                  text={'Save'}
                  onClick={() => onSave('S')}
                  disabled={evaluationData?.reportTaskStatusCode === 'TC' || isSaving}
                />
                <Button
                  className="btn-basic pink ml-1"
                  text={'Submit'}
                  onClick={() => onSave('C')}
                  disabled={evaluationData?.reportTaskStatusCode === 'TC' || isSaving}
                />
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="comm-table__area rowType">
              <table>
                <colgroup>
                  <col width="160" />
                  <col width="160" />
                  <col width="*" />
                </colgroup>
                <tbody>
                  <tr>
                    <th colSpan={2} className="text-center">Overall Comment</th>
                    <td>
                      <div className="assessment-text__area" >
                        {evaluationData?.aiGeneralCommentEn}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th colSpan={2} className="text-center">Strength</th>
                    <td>
                      <div className="assessment-text__area" >
                        {evaluationData?.stAiComment}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th colSpan={2} className="text-center">Area for Improvement</th>
                    <td>
                      <div className="assessment-text__area" >
                        {evaluationData?.wkAiComment}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th className="text-center" colSpan={2}>Interaction</th>
                    <td rowSpan={2}>
                      <div className="assessment-text__area" >
                        {evaluationData?.aiCommentIn}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th className="text-center">Score</th>
                    <th className="text-center">{evaluationData?.aiScoreIn}</th>
                  </tr>
                  <tr>
                    <th className="text-center" colSpan={2}>Coherence</th>
                    <td rowSpan={2}>
                      <div className="assessment-text__area" >
                        {evaluationData?.aiCommentCo}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th className="text-center">Score</th>
                    <th className="text-center">{evaluationData?.aiScoreCo}</th>
                  </tr>
                  <tr>
                    <th className="text-center" colSpan={2}>Language Use</th>
                    <td rowSpan={2}>
                      <div className="assessment-text__area" >
                        {evaluationData?.aiCommentLu}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th className="text-center">Score</th>
                    <th className="text-center">{evaluationData?.aiScoreLu}</th>
                  </tr>
                </tbody>
              </table>
            </div>
            {evaluationData?.reportTaskStatusCode !== 'TC' && (
              <p className="not-commenced__text">The teacher evaluation has not yet commenced.</p>
            )}
          </>
        )}
      </div>
    </Block>
  );
};

export default TutorAssessCb;